export default {
  _section: () => import('./DynamicWidgets/WidgetSection.vue'),
  _column: () => import('./DynamicWidgets/WidgetColumn.vue'),
  _h4_title: () => import('./DynamicWidgets/WidgetH4Title.vue'),
  _h2_title: () => import('./DynamicWidgets/WidgetH2Title.vue'),
  'Module/Urunler/UrunLists': () => import('./DynamicWidgets/WidgetListProducts.vue'),
  'Module/Urunler/UrunList': () => import('./DynamicWidgets/WidgetCategoryProducts.vue'),
};
